// React
import Product from 'models/Product';
import React, { useEffect, useState } from 'react';
// External
import { Card, ListGroup } from 'react-bootstrap';
import { Check2 } from 'react-bootstrap-icons';
import { FaDollarSign } from 'react-icons/fa';
// Internal
// Services
import ProductService from 'services/product';
// Styles
import './styles.scss';

/**
 * @param {Object} props.item - The item to be display with name, price and the list of products
 * @param {Boolean} props.isSelected - If product is marked as selected
 */
const BundleCard = (props) => {
    const [products, setProducts] = useState([]);

    const getProductChildren = () => {
        ProductService.getProductOptions(props.item.id)
            .then((response) => {
                if (response.data.length) {
                    setProducts(response.data.map((product) => Product(product)));
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        // Update the document title using the browser API
        getProductChildren();
    }, [props.item.id]);

    return (
        <Card className="bundle-card" onClick={() => props.onClick()}>
            <h6><b>{props.item.name}</b></h6>

            <br />
            <p>
                {props.item.description}
            </p>
            <div className="align-right">
                <p> Details </p>
            </div>
            {/* <p>
                <FaDollarSign size="12" className="dollar-sign-icon" />
                {props.item.discountPrice}
            </p> */}
            <ListGroup variant="flush">
                {
                    products.map((product, index) => (
                        <ListGroup.Item key={index}>{product.name}</ListGroup.Item>
                    ))
                }
            </ListGroup>
            {/* {
                props.isSelected
                    ? (
                        <div className="is-selected-container">
                            <Check2
                                className="check-icon"
                                color="white"
                            />
                            <span>Selected</span>
                        </div>
                    ) : null
            } */}
        </Card>
    );
};

export default BundleCard;
